import { capitalize } from 'lodash';
import PropTypes from 'prop-types';

import { amountReadable } from '../../utils/functions';
import PropTypesPresenter from '../../utils/PropTypesPresenter';
import BonusPresenter from '../../presenters/Membership/BonusPresenter';
import PaymentPresenter from '../../presenters/Membership/PaymentPresenter';
import DatePresenter from '../../presenters/DatePresenter';

export const ACTIVE = 'active';
const PENDING = 'pending';
const CANCELED = 'canceled';
export const REACTIVATED = 'reactivated';
export const ARCHIVED = 'archived';

export const MEMBERSHIP_STATES = {
  active: ACTIVE,
  pending: PENDING,
  canceled: CANCELED,
  reactivated: REACTIVATED,
  archived: ARCHIVED,
};

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    state: PropTypes.string,
    expiresAt: PropTypes.string,
    createdAt: PropTypes.string,
    bonuses: PropTypes.arrayOf(BonusPresenter.shape()),
    payments: PropTypes.arrayOf(PaymentPresenter.shape()),
    bonusesAmount: PropTypes.number,
    paymentsAmount: PropTypes.number,
  },
  {
    isActive(membership) {
      return this.state(membership) === ACTIVE;
    },
    isReactivated(membership) {
      return this.state(membership) === REACTIVATED;
    },
    isCanceled(membership) {
      return this.state(membership) === CANCELED;
    },
    isArchived(membership) {
      return this.state(membership) === ARCHIVED;
    },
    isInactive(membership) {
      return !(this.isActive(membership) || this.isReactivated(membership));
    },
    canCancel(membership) {
      return this.isActive(membership) || this.isReactivated(membership);
    },
    createdAtReadable(membership) {
      const createdAt = this.createdAt(membership);
      return DatePresenter.shortFormattedDate(createdAt);
    },
    periodReadable(membership) {
      const startDate = DatePresenter.americanShortFormattedDate(
        this.createdAt(membership)
      );
      const endDate = DatePresenter.americanShortFormattedDate(
        this.expiresAt(membership)
      );
      return `${startDate} - ${endDate}`;
    },
    bonusesAmountReadable(membership) {
      const bonusesAmount = this.bonusesAmount(membership);

      return amountReadable(bonusesAmount);
    },
    paymentsAmountReadable(membership) {
      const paymentsAmount = this.paymentsAmount(membership);

      return amountReadable(paymentsAmount);
    },
    stateReadable(membership) {
      const membershipState = this.state(membership);
      return capitalize(membershipState);
    },
  }
);
